import React, { useCallback } from 'react';
import EDMenuButton from '../../../../../BaseComponents/Buttons/MenuButton/EDMenuButton';
import MenuButtonItem from '../../../../../BaseComponents/Buttons/MenuButton/EDMenuButtonItem';
import {
  ICustomAddButtonProps,
  IRenderButtonProps,
} from '../../../_Common/Const/Delsystem';
export const TestRutin2CustomAdd: React.FC<
  React.PropsWithChildren<ICustomAddButtonProps>
> = props => {
  const { setNewObject, renderButton } = props;
  const onClick1 = useCallback(() => setNewObject?.(), [setNewObject]);
  const onClick2 = useCallback(
    () => setNewObject?.('Åkes Åkeri AB'),
    [setNewObject]
  );
  const onClick3 = useCallback(() => {
    throw new Error('Fel val vid tillägg i testrutin 2');
  }, []);

  const renderTrigger = useCallback(
    ({ onClick, disabled, icon, label }: IRenderButtonProps) =>
      renderButton?.({ onClick, disabled, icon, label }) as React.ReactElement,
    [renderButton]
  );

  return (
    <EDMenuButton
      icon="add"
      iconSize="default"
      tooltip="Skapa ny"
      buttonLabel={props.smallMenu ? 'Skapa ny' : undefined}
      captionLabel={props.smallMenu}
      color="inherit"
      padding="normal"
      margin="none"
      renderButton={renderButton ? renderTrigger : undefined}
    >
      <MenuButtonItem onClick={onClick1}>Vanligt tillägg</MenuButtonItem>
      <MenuButtonItem onClick={onClick2}>
        Lägg till &quot;Åkes Åkeri&quot;
      </MenuButtonItem>
      <MenuButtonItem onClick={onClick3}>Tryck här för fel!</MenuButtonItem>
    </EDMenuButton>
  );
};
